import React from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton, useTheme } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';

function Header({ onThemeToggle, isDarkMode }) {
  const theme = useTheme();

  return (
    <AppBar position="static" sx={{ backgroundColor: theme.palette.mode === 'dark' ? '#464047' : '#333' }}>
      <Toolbar
        sx={{
          display: 'flex',
          flexDirection: { xs: 'row', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: '64px', // Set the minimum height for the Toolbar
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <Typography variant="h6" sx={{ color: 'white', mr: { sm: '20px' }, mb: { xs: '10px', sm: '0' } }}>
            Portfolio
          </Typography>
          <ArrowForwardIcon sx={{ color: 'white', fontSize: '1.5rem' }} />
        </div>
        <nav sx={{ display: { xs: 'none', sm: 'flex' }, flexGrow: 1, justifyContent: 'space-evenly', fontSize: { sm: '0.875rem' } }}>
          <Link to="/" className="nav-link" >
            <Button sx={{ color: 'white',textDecoration: 'underline' }}>Home</Button>
          </Link>
          <Link to="/projects" className="nav-link">
            <Button sx={{ color: 'white',textDecoration: 'underline' }}>Projects</Button>
          </Link>
          <Link to="/Certifications & Skills" className="nav-link">
            <Button sx={{ color: 'white',textDecoration: 'underline' }}> Certifications & Skills</Button>
          </Link>
          <Link to="/contacts" className="nav-link">
            <Button sx={{ color: 'white',textDecoration: 'underline' }}>Contacts</Button>
          </Link>
        </nav>
        <IconButton onClick={onThemeToggle} sx={{ color: 'white', p: '8px' }}>
        {isDarkMode ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>

      </Toolbar>
    </AppBar>
  );
}

export default Header;
